import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Input, Button, Dropdown, Popup, Icon} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Detail from './detail';
import './list.scss';

const today = moment().format(noTimeZoneShortISODate);
const ALL_STATUS = 'ALL';
const OFFSET = 0;
const statusOptions = [
  {'text': 'Todos', 'value': ALL_STATUS},
  {'text': 'Disponible', 'value': 'AVAILABLE'},
  {'text': 'No Disponible', 'value': 'NO_AVAILABLE'},
];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showVehiclesInfo': true,
      'startDateFilter': today,
      'endDateFilter': today,
      'chassis': '',
      'status': ALL_STATUS,
    };
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.vehiclesAvailability, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchJDEParameters();
    this.onSearchClick(OFFSET);
  }

  changeStartDate(date) {
    const dateFormatted = date ? moment(date).format(noTimeZoneShortISODate) : '';

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }

    const newState = {'showVehiclesInfo': false, 'startDateFilter': dateFormatted};
    if (date) {
      if (!endDateFilter || (endDateFilter && moment(date) > moment(endDateFilter))) {
        newState.endDateFilter = dateFormatted;
      }
    }
    this.setState(newState);
  }

  changeEndDate(date) {
    const dateFormatted = date ? moment(date).format(noTimeZoneShortISODate) : '';

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }

    this.setState({'showVehiclesInfo': false, 'endDateFilter': dateFormatted});
  }

  onChangeValues(value, field) {
    const {showVehiclesInfo} = this.state;
    const currentValue = this.state[field];
    if (currentValue === value) {
      return;
    }

    const newState = {};
    newState[field] = value.toUpperCase();

    if (showVehiclesInfo) {
      newState.showVehiclesInfo = false;
    }
    this.setState(newState);
  }

  onClearClick() {
    this.setState({
      'showVehiclesInfo': false,
      'startDateFilter': today,
      'endDateFilter': today,
      'chassis': '',
      'status': ALL_STATUS,
    }, () => this.onSearchClick(OFFSET));
  }

  onSearchClick(offset) {
    const {pageSize} = this.props;
    this.setState({'showVehiclesInfo': true});
    this.props.changeListPage(offset);
    this.props.fetchVehiclesAvailability(this.getParameters(), pageSize, offset);
  }

  getParameters() {
    const {startDateFilter, endDateFilter, chassis, status} = this.state;
    const parameters = {
      'startDate': startDateFilter,
      'endDate': endDateFilter,
      chassis,
    };
    if (status !== ALL_STATUS) {
      parameters.status = status.toLowerCase();
    }
    return parameters;
  }

  render() {
    const {loading, updating} = this.props;
    const {showVehiclesInfo, startDateFilter, endDateFilter, chassis, status} = this.state;

    return (
      <div className='vehicles-availability-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8} >
                  <div className='title'>
                    <h2>Disponibilidad de Vehículos</h2>
                    <Popup
                      trigger={
                        <Icon link name='info circle' color='blue' size='large' />
                      }
                      on='click'
                      position='bottom left'
                      inverted
                    >
                      <div>
                        <p>Definición de los colores:</p>
                        <ul>
                          <li>
                            <strong>Verde:</strong> El chasis está listo para facturar
                          </li>
                          <li>
                            <strong>Rojo:</strong>
                            El chasis está pendiente y no se puede cambiar a listo
                            porque hay órdenes que aún están abiertas
                          </li>
                          <li>
                            <strong>Sin color:</strong> El chasis se puede pasar a
                            listo para facturar
                          </li>
                        </ul>
                      </div>
                    </Popup>
                  </div>
                </Grid.Column>
                <Grid.Column width={8} textAlign='right'>
                  <Button
                    secondary
                    type='button'
                    disabled={loading || updating}
                    onClick={this.onClearClick}
                  >
                    Limpiar
                  </Button>
                  <Button
                    type='button'
                    primary
                    disabled={loading || updating || (!startDateFilter && endDateFilter) ||
                      (!startDateFilter && !chassis)}
                    onClick={() => this.onSearchClick(OFFSET)}
                  >
                    Buscar
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div className='filters-section'>
              <Grid>
                <Grid.Row textAlign='left'>
                  <Grid.Column width={1} className='label'>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        startDateFilter ?
                          moment(
                            startDateFilter,
                            noTimeZoneShortISODate
                          ).toDate() :
                          null
                      }
                      onChange={this.changeStartDate}
                      locale='es'
                      placeholderText='Fecha Inicio'
                      disabled={loading || updating}
                    />
                  </Grid.Column>
                  <Grid.Column width={1} className='label'>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        endDateFilter ?
                          moment(
                            endDateFilter,
                            noTimeZoneShortISODate
                          ).toDate() :
                          null
                      }
                      onChange={this.changeEndDate}
                      minDate={moment(startDateFilter).toDate()}
                      placeholderText='Fecha Fin'
                      disabled={loading || updating}
                      locale='es'
                      todayButton='Hoy'
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Chasis</h4>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Input
                      value={chassis}
                      disabled={loading || updating}
                      onChange={(e, {value}) =>
                        this.onChangeValues(value, 'chassis')
                      }
                      placeholder='Chasis'
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Estado</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Dropdown
                      selection
                      options={statusOptions}
                      value={status}
                      disabled={loading || updating}
                      onChange={(e, {value}) =>
                        this.onChangeValues(value, 'status')
                      }
                      placeholder='Seleccione Estado'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        {showVehiclesInfo && <Detail parameters={this.getParameters()} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehiclesAvailability.loading,
    'updating': state.vehiclesAvailability.updating,
    'pageSize': state.vehiclesAvailability.pageSize,
    'permissions': state.session.permissions,
  };
};

const {
  fetchVehiclesAvailability,
  fetchJDEParameters,
  changeListPage,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchVehiclesAvailability,
  fetchJDEParameters,
  changeListPage,
  navigateTo,
})(Index);
